<template>
  <div class="fin-reg-dem">
    <!-- APRESENTA A OPÇÃO CARREGANDO NA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    
    <!-- APRESENTA O CONTEUDO DA TELA -->
    <template v-else>
      <!-- SETA A TELA DE PESQUISA E RELATORIO -->
      <div v-if="pesquisa !== null" style="margin-bottom: 20px;">
        <App-Financeiro-Relatorios :key="pesquisa.demandaId"
        :cpntDemanda="pesquisa.demanda"
        :cpntDemandaId="pesquisa.demandaId"
        ></App-Financeiro-Relatorios>
      </div>

      <!-- SETA AS OPÇÕES QUE PODEM REGISTRAR -->
      <div class="campos" :class="('selecionado--' + value)">
        <div v-for="item in opcoes" :key="'dem--' + item.demanda" :class="('qtde-opcoes--' + opcoes.length) + ' ' + ('fin-reg-dem--' + item.demanda)">
          <input :id='"fin-reg-dem--" + item.demanda' type="radio" class="app-checkbox" v-model="value" :value="item.demanda" @change="finRegistrarOnChange">
          <label :for='"fin-reg-dem--" + item.demanda'>
            <!-- SETA O NOME DA OPÇÃO -->
            <span v-html="item.nome"></span>

            <!-- SETA O NUMERO DE REGISTROS PENDENTES -->
            <span class="numero" v-if="[ '', null, undefined ].indexOf(item.numero) === -1" :title="item.numero.title">
              ( <span v-html="item.numero.value"></span> )
            </span>
          </label>
        </div>
      </div>
      
      <!-- SETA O LOCAL QUE VAI ABRIR OS DADOS DA TELA SELECIONADA -->
      <router-view @FINANCEIRO_SETAR_PESQUISA="finRegistrarSetarPesquisa"></router-view>
    </template>
  </div>
</template>

<style scoped>
  .fin-reg-dem > .campos {
    margin-top: 30px;
    text-align: center;
  }
    .fin-reg-dem > .campos > div {
      display: inline-block;
      text-align: center;
    }
    .fin-reg-dem > .campos > div.qtde-opcoes--1 {
      width: calc(100%);
      max-width: 200px;
    }
    .fin-reg-dem > .campos > div.qtde-opcoes--2 {
      width: calc((100% / 2) - (20px / 2));
      max-width: 200px;
    }
    .fin-reg-dem > .campos > div.qtde-opcoes--3 {
      width: calc((100% / 3) - (40px / 3));
      max-width: 200px;
    }
    .fin-reg-dem > .campos > div.qtde-opcoes--4 {
      width: calc((100% / 4) - (60px / 4));
      max-width: 200px;
    }
    .fin-reg-dem > .campos > div {
      margin-left: 20px;
    }
    .fin-reg-dem > .campos > div > label > .numero {
      font-weight: bold;
      margin-left: 3px;
      font-size: 17px;
    }
      .fin-reg-dem > .campos > div > label > .numero > span {
        color: red;
      }

    .fin-reg-dem > .selecionado--venda > .fin-reg-dem--venda > label,
    .fin-reg-dem > .selecionado--projeto > .fin-reg-dem--projeto > label,
    .fin-reg-dem > .selecionado--escola > .fin-reg-dem--escola > label,
    .fin-reg-dem > .selecionado--despesa > .fin-reg-dem--despesa > label,
    .fin-reg-dem > .selecionado--compra > .fin-reg-dem--compra > label,
    .fin-reg-dem > .selecionado--comissao > .fin-reg-dem--comissao > label {
      font-weight: bold !important;
    }
</style>

<style>
</style>

<script>
  export default {
    components: {
      'App-Financeiro-Relatorios': () => import('@/components/financeiro/Relatorio/Financeiro-Relatorios.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        opcoes: [],
        value: '',
        perHelenir: false,
        pesquisa: null
      }
    },
    mounted: function () {
      this.finRegistrarVerificarPersonalizacao()
    },
    methods: {
      finRegistrarSetarPesquisa: function (vetor) {
        // SETA O VALOR RECEBIDO
        this.pesquisa = vetor

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS NUMEROS
        this.finRegistrarBuscarNumerosAtualizados()
      },
      finRegistrarVerificarPersonalizacao: function () {
        // SETA O STATUS DA PAGINA
        this.finRegistrarSetarStatusGeral('carregando')

        // VERIFICA SE TEM PERSONALIZAÇÃO
        if (this.$route.params.tipo !== 'despesa') {
          this.finRegistrarIniciar()
        } else {
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/subase/personalizacao/chk-irma-helenir', 'GET', null, (retorno) => {
            // SETA O FLAG SE É UMA PERSONALIZAÇÃO IRMÃ HELENIR
            this.perHelenir = retorno.data !== '0'

            // CHAMA A TELA PARA INICIAR
            this.finRegistrarIniciar()
          }, this.finRegistrarSetarStatusGeral)
        }
      },
      finRegistrarIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.finRegistrarSetarStatusGeral('carregando')

        // INICIA A VARIAVEL
        var opcoes = []
        var selecao = ''

        // VERIFICA O TIPO DE INFORMAÇÃO QUE DEVE CARREGAR
        switch (this.$route.params.tipo) {
          case 'despesa':
            // SETA O BOTÃO PADRÃO PARA TODOS OS PACOTES
            opcoes.push({ ref: '0', menuInfo: '', demanda: 'avulsa', nome: 'Despesa Avulsa' })

            // VERIFICA SE DEVE MOSTRAR OU NÃO AS OPÇÕES
            if (this.perHelenir === false) {
              // ADICIONA O BOTÃO DESPESA
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, null, null, null, null, false) === true) {
                opcoes.push({ ref: '4', menuInfo: '8.1.4', demanda: 'despesa', nome: 'Despesa', numero: { value: '...', title: '' } })
              }
      
              // ADICIONA O BOTÃO PROJETO
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, null, null, null, null, false) === true) {
                // SETA A OPÇÃO NA TELA
                opcoes.push({ ref: '5', menuInfo: '8.1.5', demanda: 'compra', nome: 'Compra', numero: { value: '...', title: '' } })
                
                // SETA O VALOR INICIAL DO CAMPO
                if (selecao === '') {
                  selecao = 'compra'
                }
              }
      
              // ADICIONA O BOTÃO COMISSÃO
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === true) {
                // SETA A OPÇÃO NA TELA
                opcoes.push({ ref: '27', menuInfo: '8.1.27', demanda: 'comissao', nome: 'Comissão', numero: { value: '...', title: '' } })
                
                // SETA O VALOR INICIAL DO CAMPO
                if (selecao === '') {
                  selecao = 'comissao'
                }
              }
            }
            break

          case 'receita':
            // SETA O BOTÃO PADRÃO PARA TODOS OS PACOTES
            opcoes.push({ ref: '0', menuInfo: '', demanda: 'avulsa', nome: 'Receita Avulsa' })
    
            // ADICIONA O BOTÃO VENDA
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, null, null, null, null, false) === true) {
              // SETA A OPÇÃO NA TELA
              opcoes.push({ ref: '17', menuInfo: '7.1.17', demanda: 'venda', nome: 'Venda', numero: { value: '...', title: '' } })
              
              // SETA O VALOR INICIAL DO CAMPO
              if (selecao === '') {
                selecao = 'venda'
              }
            }
    
            // ADICIONA O BOTÃO PROJETO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 10 ], null, null, null, null, null, false) === true) {
              // SETA A OPÇÃO NA TELA
              opcoes.push({ ref: '10', menuInfo: '7.1.10', demanda: 'projeto', nome: 'Projeto-fase', numero: { value: '...', title: '' } })
              
              // SETA O VALOR INICIAL DO CAMPO
              if (selecao === '') {
                selecao = 'projeto'
              }
            }
    
            // ADICIONA O BOTÃO ESCOLA
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 22 ], null, null, null, null, null, false) === true) {
              // SETA A OPÇÃO NA TELA
              opcoes.push({ ref: '22', menuInfo: '7.1.22', demanda: 'escola', nome: 'Matrícula', numero: { value: '...', title: '' } })
              
              // SETA O VALOR INICIAL DO CAMPO
              if (selecao === '') {
                selecao = 'escola'
              }
            }
            break
        }

        // SETA O VALOR DA VARIAVEL SE ELA NÃO FOI DEFINIDA
        if (selecao === '') {
          selecao = 'avulsa'
        }

        // SETA AS OPÇÕES MONTADAS
        this.opcoes = opcoes

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS NUMEROS
        this.finRegistrarBuscarNumerosAtualizados()

        // VERIFICA A OPÇÃO SOLICITADA
        if (this.$route.name === 'financeiro_registrar_tipo' && [ '', null, undefined ].indexOf(this.$route.params.demanda) === -1) {
          // SETA A OPÇÃO SELECIONADA
          this.value = this.$route.params.demanda

          // REALIZA A ALTERAÇÃO DE TELA
          setTimeout(() => { this.finRegistrarOnChange() }, 0)

          // LIMPA O STATUS DA TELA
          this.finRegistrarSetarStatusGeral('')
        } else if (this.$route.name === 'financeiro_registrar_tipo_id' && [ '', null, undefined ].indexOf(this.$route.params.demanda) === -1) {
          // SETA A OPÇÃO SELECIONADA
          this.value = this.$route.params.demanda

          // LIMPA O STATUS DA TELA
          this.finRegistrarSetarStatusGeral('')
        } else {
          // SETA A OPÇÃO SELECIONADA
          this.value = selecao

          // REALIZA A ALTERAÇÃO DE TELA
          setTimeout(() => { this.finRegistrarOnChange() }, 0)

          // LIMPA O STATUS DA TELA
          this.finRegistrarSetarStatusGeral('')
        }
      },
      finRegistrarSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegistrarBuscarNumerosAtualizados: function () {
        // MANDA ATUALIZAR AS INFORMAÇÕES DO MENU
        this.$store.commit('SET_INFO_MENU', () => {
          // SETA OS NUMEROS DE INFORMAÇÕES A SEREM REGISTRADAS
          for (var indexO in this.opcoes) {
            // VERIFICA SE TEM NUMERO PARA APRESENTAR
            if ([ '', null, undefined ].indexOf(this.opcoes[indexO].numero) === -1 && [ '', null, undefined ].indexOf(this.opcoes[indexO].menuInfo) === -1) {
              // PROCURA O NUMERO A SER APRESENTADO
              var numero = this.$store.state.menuInfo.filter(item => item.id === this.opcoes[indexO].menuInfo)

              // PEGA O VALOR RECEBIDO
              numero = numero.length >= 1 ? numero[0] : { value: '0', title: '' }

              // SETA O NUMERO ENCONTRADO
              this.opcoes[indexO].numero = numero
            }

          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      finRegistrarOnChange: function () {
        setTimeout(() => {
          if ([ 'financeiro_registrar', 'financeiro_registrar_tipo_id', 'financeiro_registrar_tipo' ].indexOf(this.$route.name) !== -1) {
            // PEGA A OPÇÃO SELECIONADA
            var option = this.opcoes.filter(item => item.demanda === this.value)

            // PEGA O VALOR ENCONTRADO
            option = option.length >= 1 ? option[0] : null

            // VERIFICA SE FOI ENCONTRADO O VALOR
            if (option === null) {
              // RETORNA PARA TELA ANTERIOR
              this.$router.push({ name: 'financeiro_registrar_tipo', params: { tipo: this.$route.params.tipo, demanda: this.$route.params.demanda } })

              // LIMPA O VALOR SELECIONANDO
              this.value = ''

              // APRESENTA MENSAGEM DE ERRO
              this.$store.state.msgWarn('WEB [406]: Registro não encontrado para registrar no financeiro.', 'warning')
            } else {  
              switch (this.$route.params.tipo + '__' + this.value) {
                case 'receita__venda':
                case 'despesa__compra':
                  this.$router.push({ name: 'financeiro_registrar_tipo', params: { tipo: this.$route.params.tipo, demanda: this.value } })
                  break
    
                case 'receita__avulsa':
                case 'receita__projeto':
                case 'receita__escola':
                  this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/financeiro/fin_receita.php?cts=' + this.$store.state.token.cts + '&rec_sel=' + option.ref, '_self')
                  break
    
                case 'despesa__avulsa':
                case 'despesa__despesa':
                case 'despesa__comissao':
                  this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/financeiro/fin_despesa.php?cts=' + this.$store.state.token.cts + '&des_sel=' + option.ref, '_self')
                  break
              }
            }
          }
        }, 100)
      }
    },
    watch: {
      '$route.params.tipo': function () {
        if ([ 'financeiro_registrar', 'financeiro_registrar_tipo_id', 'financeiro_registrar_tipo' ].indexOf(this.$route.name) !== -1) {
          // LIMPA A PESQUISA DA TELA
          this.pesquisa = null
  
          // REINICIA O CARREGAMENTO
          setTimeout(() => { this.finRegistrarIniciar() }, 0)
        }
      }
    }
  }
</script>
